const API_URL: string = process.env.VUE_APP_API_URL + "/";
const PAYJOY_API_BASE_URL: string = process.env.VUE_APP_PAYJOY_API_URL + "/";
const MERCHANT2_API_URL: string = process.env.VUE_APP_MERCHANT2_API_URL + "/";

let registrationEndpoint: string = API_URL + "registrations";

// @juusechec this change is going to be removed since the VUE_APP_PERSONS_API_BASE_URL will be the only way of configuring this endpoint
export const setRegistrationEndpoint = (endpoint: string): void => {
  registrationEndpoint = endpoint;
};

export const getRegistrationEndpoint = (): string => {
  return registrationEndpoint;
};

export const registrationApiUrls = (
  registationTag?: string
): Record<string, string> => {
  return {
    ACCEPT_PRIVACY_POLICIES: `${registrationEndpoint}/${registationTag}/privacy-policy-accept`,
    ACCEPT_TERMS: `${registrationEndpoint}/${registationTag}/terms-accept`,
    CREATE_REGISTRATION: `${registrationEndpoint}`,
    EMAIL_VERIFY: `${registrationEndpoint}/${registationTag}/email-verify`,
    GET_ID_IMAGES: `${registrationEndpoint}/${registationTag}/id-images`,
    GET_REGISTRATION: `${registrationEndpoint}/${registationTag}`,
    GET_RFC: `${registrationEndpoint}/${registationTag}/rfc`,
    GET_VERSION_HASH: `${registrationEndpoint}/${registationTag}/version-hash`,
    INCODE_ONBOARDING_URL: `${registrationEndpoint}/${registationTag}/incode-onboarding-url`,
    MARK_REGISTRATION_AS_OPEN: `${registrationEndpoint}/${registationTag}/open`,
    MOVE_NEXT_MILESTONE: `${registrationEndpoint}/${registationTag}/milestones/next`,
    MOVE_PREVIOUS_MILESTONE: `${registrationEndpoint}/${registationTag}/milestones/previous`,
    OMIT_PAYMENT_METHOD: `${registrationEndpoint}/${registationTag}/omit-payment-method`,
    PHONE_VERIFY: `${registrationEndpoint}/${registationTag}/phone-verify`,
    RECORD_ADDRESS: `${registrationEndpoint}/${registationTag}/address`,
    RECORD_EMAIL: `${registrationEndpoint}/${registationTag}/email`,
    RECORD_PASSWORD: `${registrationEndpoint}/${registationTag}/password`,
    RECORD_PAYMENT_METHOD: `${registrationEndpoint}/${registationTag}/payment-methods-mx-spei`,
    RECORD_PHONE: `${registrationEndpoint}/${registationTag}/phone`,
    RECORD_MILESTONE: `${registrationEndpoint}/${registationTag}/milestone`,
    START_INCODE_SESSION: `${registrationEndpoint}/${registationTag}/incode-onboarding`,
    UPLOAD_BACK_IDENTIFICATION_IMAGE: `${registrationEndpoint}/${registationTag}/id-images/back`,
    UPLOAD_FRONT_IDENTIFICATION_IMAGE: `${registrationEndpoint}/${registationTag}/id-images/front`,
    UPLOAD_PROOF_OF_ADDRESS_IMAGE: `${registrationEndpoint}/${registationTag}/id-images/proof-of-address`,
    UPLOAD_SELFIE_IDENTIFICATION_IMAGE: `${registrationEndpoint}/${registationTag}/id-images/selfie`,
    CX_TICKET_STATUS: `${registrationEndpoint}/${registationTag}/cx-ticket-status`,
    CANCEL_REGISTRATION: `${registrationEndpoint}/${registationTag}/cancel`,
  };
};

export const documentApiUrls = {
  PRIVACY_POLICY: `${API_URL}documents/privacy-policy`,
  TERMS_AND_CONDITIONS: `${API_URL}user-management/documents/terms`,
};

export const chatBotConfigApiUrl = {
  CHATBOT_CONFIGURATION: `${PAYJOY_API_BASE_URL}chatbot/get-chatbot-configs.php`,
};

export const authenticationApiUrls = {
  SIGN_IN: `${API_URL}auth/login`,
  SIGN_UP: `${API_URL}sign-up`,
  SIGN_OUT: `${API_URL}global-sign-out`,
  FORGOT_PASSWORD: `${API_URL}auth/forgot-password`,
  CONFIRM_FORGOT_PASSWORD: `${API_URL}auth/confirm-forgot-password`,
  CONFIRM_SIGN_UP: `${API_URL}confirm-sign-up`,
  MERCHANT_SING_IN: `${MERCHANT2_API_URL}login`,
  MERCHANT_SING_IN1: `${process.env.VUE_APP_MERCHANT2_API_URL}/login`,
};
